<div ly-dialog-content [lyPx]="0">
  <div *ngIf="ready">
    <button (click)="cropper.zoomIn()" mat-button appearance="icon">
      <ly-icon>zoom_in</ly-icon>
    </button>
    <button (click)="cropper.zoomOut()" mat-button appearance="icon">
      <ly-icon>zoom_out</ly-icon>
    </button>
    <button (click)="cropper.center()" mat-button appearance="icon">
      <ly-icon>filter_center_focus</ly-icon>
    </button>
    <button (click)="cropper.rotate(-90)" mat-button appearance="icon">
      <ly-icon>rotate_90_degrees_ccw</ly-icon>
    </button>
    <button (click)="cropper.fit()" mat-button>Ajustar</button>
    <button (click)="cropper.fitToScreen()" mat-button>Ajustar a tela</button>
    <button (click)="cropper.setScale(1)" mat-button>1:1</button>
    <button (click)="cropper.clean()" mat-button>Limpar</button>
  </div>
  <ly-img-cropper
    [withClass]="classes.cropper"
    [config]="myConfig"
    [(scale)]="scale"
    (minScale)="minScale = $event"
    (ready)="ready = true"
    (cleaned)="ready = false"
    (cropped)="onCropped($event)"
    (loaded)="onLoaded($event)"
    (error)="onError($event)"
  >
  <div class="d-flex" style="flex-wrap: wrap; justify-content: center">
    <span class="mx-3 btn btn-primary d-block">Clique aqui para selecionar uma Imagem</span>
    <span
      class="m-3 d-block"
      style=" width: 100%;
        height: 100px;
        text-align: center;
        border: 1px solid;
        padding: 12px;"
      >Ou arraste um arquivo de imagem.</span
    >
  </div>
  </ly-img-cropper>
  <div *ngIf="ready" [className]="classes.sliderContainer">
    <ly-slider
      [thumbVisible]="false"
      [min]="minScale"
      [max]="1"
      [(ngModel)]="scale"
      (input)="scale = $event.value"
      step="0.000001"
    ></ly-slider>
  </div>
</div>
<div container [lyJustifyContent]="'flex-end'" ly-dialog-actions>
  <button
    class="btn btn-secondary rounded-pill mx-1"
    (click)="dialogRef.close()"
  >
    Fechar
  </button>
  <!-- <button color="primary" (click)="dialogRef.close(cropper)" [disabled]="!ready">Salvar</button> -->
  <button
    class="btn btn-success rounded-pill mx-1"
    (click)="dialogRef.close(cropper.crop())"
    [disabled]="!ready"
  >
    Salvar
  </button>
</div>
